export default {
  margin: {
    xs: '0.625rem',
    sm: '0.9375rem',
    md: '0.9375rem',
    lg: '1.125rem',
    xl: '1.25rem',
    negative: {
      xs: '-0.625rem',
      sm: '-0.9375rem',
      md: '-0.9375rem',
      lg: '-1.125rem',
      xl: '-1.25rem',
    },
  },
  padding: {
    xs: '0.625rem',
    sm: '0.9375rem',
    md: '0.9375rem',
    lg: '1.125rem',
    xl: '1.25rem',
  },
};
